import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const clientData = (id?: string, response?: any, plans?: any): FormProps[] => {

    const data: FormProps[] = [
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Nome do cliente*',
            value: id ? response?.name : null,
            rules: {
                required: 'O nome do cliente é obrigatório'
            },
            name: 'name',
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Descrição do cliente*',
            rules: {
                required: 'A descrição do cliente é obrigatória'
            },
            value: id ? response?.description : null,
            name: 'description',
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Plano do cliente*',
            rules: {
                required: 'O plano do cliente é obrigatório'
            },
            value: id ? response?.planId : null,
            name: 'planId',
            options: {
                placeholder: 'Plano do cliente',
                data: plans,
                value: id ? response?.planId : null
            }
        },
        {
            typeOfField: FormTypes.DATE,
            type: 'text',
            placeholder: 'Data inicial do contrato',
            value: (response?.planInitialDate? response?.planInitialDate : response?.createdAt),
            name: 'planInitialDate',
            width: 500,
            height: 55,
        },
        {
            typeOfField: FormTypes.DATE,
            type: 'text',
            placeholder: 'Data final do contrato',
            value: (response?.planDueDate? response.planDueDate : null),
            name: 'planDueDate',
            width: 500,
            height: 55,
        },
    ];

    return data;
};

export default clientData;